//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props:['show'],
    data(){
        return{
            opening: false,
        }
    },
    watch:{
        show(n,o){
            if(n&&!o){
                setTimeout(()=>{
                    this.opening=true
                },100)
            }else{
                this.opening=false
            }
        }
    },
    methods:{
        close(){
            if(this.opening){
                this.$emit('close')
                this.send = false
            }
        },
    }
}
